import { render } from "./Empty.vue?vue&type=template&id=2a42b818"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"
script.render = render

export default script